import { DOCUMENT, CommonModule } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { ChatService } from './services/chat.service';
import { SideBarService } from './services/sidebar.service';
import { StateService } from './services/state.service';
import { PinnedQueryService } from './services/pinned-query.service';
import { MainComponent } from './shared/layout/main/main.component';
import { SideBarComponent } from './components/sidebar/sidebar.component';
import { ChatComponent } from './components/chat/chat.component';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'fyxt-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [CommonModule, RouterOutlet, MainComponent, SideBarComponent, ChatComponent]
})
export class AppComponent {
  title = 'fyxt-chat-ui';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private themingService: ThemeService,
    private renderer: Renderer2,
    private chatService: ChatService,
    private sidebarService: SideBarService,
    private stateService: StateService,
    private pinnedQueryService: PinnedQueryService,
    public activeRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.setupTheme()
  }

  private setupTheme() {
    let currentTheme = '';
    this.themingService.theme.subscribe((theme) => {
      if (currentTheme) {
        this.renderer.removeClass(this.document.body, currentTheme);
      }
      currentTheme = theme;
      this.renderer.addClass(this.document.body, theme);
      this.activeRoute.queryParamMap.subscribe((queryParamMap: any) => {
        if (queryParamMap.params.flowId && queryParamMap.params.schema) {
          this.chatService.flowId = queryParamMap.params.flowId;
          this.chatService.currentSessionId = uuidv4();
          this.chatService.schema = queryParamMap.params.schema;
          this.chatService.user_name = queryParamMap.params.user_name;
          this.chatService.tweaks = JSON.parse(queryParamMap.params.tweaks || '{}');

          // Extract user_id from tweaks (handle both user_id and users_id)
          const tweaks = this.chatService.tweaks as Record<string, any> || {};
          const firstTweakKey = Object.keys(tweaks)[0];
          const firstTweak = tweaks[firstTweakKey] || {};
          this.chatService.user_id = firstTweak?.user_id || firstTweak?.users_id;

          this.sidebarService.storageSession = queryParamMap.params.langflow_session_id;
          this.sidebarService.parentUrl = queryParamMap.params.parentUrl;

          this.stateService.setData(queryParamMap.params);

          // Load chatbot configuration from query params (greeting message and template questions)
          if (queryParamMap.params.greeting_message) {
            this.chatService.greetingMessage = queryParamMap.params.greeting_message;
          }

          // Parse template questions from query params
          if (queryParamMap.params.template_questions) {
            try {
              const templateQuestions = JSON.parse(queryParamMap.params.template_questions);
              if (Array.isArray(templateQuestions)) {
                this.chatService.templateQuestions = templateQuestions.filter(
                  (q: { text: string }) => q && q.text && q.text.trim() !== ''
                );
              }
            } catch (e) {
              console.warn('Failed to parse template_questions from query params:', e);
              this.chatService.templateQuestions = [];
            }
          } else {
            this.chatService.templateQuestions = [];
          }

          if (this.sidebarService.storageSession) {
            this.sidebarService.loadShortSessionsInfo();
          }

          this.pinnedQueryService.loadPinnedQueries();
        }
      });
    })
  }
}
